export const MEDIQUO_PRO_SUPPORT_EMAIL = 'support.pro@mediquo.com';
